import { Component } from '@angular/core';
import { JeevesCustomerContactCardListComponent, JeevesModalService } from 'gung-standard-jeeves';
import { environment } from '../../../environments/environment';
import { Customer, SelectedCustomerService } from 'gung-standard';

@Component({
    selector: 'car-liner-customer-contact-card-list',
    templateUrl: './car-liner-customer-contact-card-list.component.html',
    styleUrl: './car-liner-customer-contact-card-list.component.scss',
    standalone: false
})
export class CarLinerCustomerContactCardListComponent extends JeevesCustomerContactCardListComponent {
  /*
  Mail to send to for JOSAM: customercare.josam@car-o-liner.se

  Mail to send to for CAR-O-LINER: customercare@car-o-liner.se
  */
  mailto: string = environment.projectName === 'josam' ? 'customercare.josam@car-o-liner.se' : environment.projectName === 'caroliner' ? 'customercare@car-o-liner.se' : '';
  customer: Customer;

  constructor(protected modalService: JeevesModalService, protected selectedCustomerService: SelectedCustomerService) {
    super(modalService);
    this.selectedCustomerService.getSelectedCustomer().subscribe(customer => {
      this.customer = customer;
    });
  }
}
